import { Link } from '@tanstack/react-router'
import { Send } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Card, CardBody } from '@/components/ui/card'
import { EmptyState } from '@/components/ui/empty-state'
import { Skeleton } from '@/components/ui/skeleton'
import { ProposalStatusBadge } from '@/components/ui/status'
import { useMyProposals } from '@/features/marketplace/api'
import { formatRelative, formatRupiah } from '@/lib/format'

export function ProposalsPage() {
  const { data, isLoading } = useMyProposals()
  const proposals = data?.proposals ?? []

  return (
    <div className="space-y-6">
      <header className="flex flex-wrap items-start justify-between gap-4">
        <div>
          <h1 className="text-2xl font-extrabold tracking-tight text-ink sm:text-3xl">Proposal saya</h1>
          <p className="mt-1 text-muted">Penawaran yang Anda kirim beserta statusnya.</p>
        </div>
        <Link to="/proyek">
          <Button variant="outline">Cari proyek baru</Button>
        </Link>
      </header>

      {isLoading ? (
        <div className="space-y-3">
          {Array.from({ length: 3 }).map((_, index) => (
            <Skeleton key={index} className="h-24 rounded-2xl" />
          ))}
        </div>
      ) : proposals.length === 0 ? (
        <Card>
          <EmptyState illustration="box"
            icon={<Send className="size-6" />}
            title="Belum ada proposal"
            description="Kirim penawaran pada proyek yang sesuai keahlian Anda."
            action={
              <Link to="/proyek">
                <Button>Lihat papan proyek</Button>
              </Link>
            }
          />
        </Card>
      ) : (
        <div className="space-y-3">
          {proposals.map((proposal) => (
            <Card key={proposal.id}>
              <CardBody className="flex flex-wrap items-start justify-between gap-4">
                <div className="min-w-0 flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <ProposalStatusBadge status={proposal.status} />
                    <span className="text-xs text-subtle">{formatRelative(proposal.created_at)}</span>
                  </div>
                  <Link to="/proyek/$jobId" params={{ jobId: proposal.job_post_id }} className="mt-2 block">
                    <h2 className="font-bold text-ink transition hover:text-brand">{proposal.job_title}</h2>
                  </Link>
                  <p className="clamp-2 mt-1 text-sm text-muted">{proposal.cover_letter}</p>
                </div>

                <div className="shrink-0 text-right">
                  <p className="font-bold tabular-nums text-ink">{formatRupiah(proposal.amount)}</p>
                  <p className="text-xs text-subtle">{proposal.duration_days} hari</p>
                </div>
              </CardBody>
            </Card>
          ))}
        </div>
      )}
    </div>
  )
}
